{
  "add-a-stream": {
    "button": "Stream hinzufügen"
  },
  "add-new-page": {
    "audio-dedications": "Audio-Shoutouts",
    "dedications": "Widmungen",
    "html": "HTML",
    "livefeed": "Live-Feed",
    "podcast": "Podcast",
    "reveil": "Alarm",
    "rss": "RSS",
    "rss-news": "Nachrichten",
    "rss-podcasts": "Podcast",
    "rss-video": "Video",
    "site": "Website",
    "song-history": "Song-Verlauf",
    "title": "Seite hinzufügen"
  },
  "android-screenshot": {
    "desc": "<p class='mb-[10px]'>Das angezeigte Bild entspricht der bei der Veröffentlichung generierten Vorschau. Dieser Status zeigt an, dass Ihre App zum ersten Mal online gestellt wurde.</p><p>Es wird nicht automatisch aktualisiert: Updates, Überprüfungen oder Warnungen müssen über Ihr Google-Entwicklerkonto verfolgt werden.</p>",
    "title": "Ihre Anwendung ist im Google Play Store verfügbar."
  },
  "app-update-available": {
    "cta": "Aktualisieren",
    "description": "Genießen Sie die neuesten App-Funktionen",
    "title": "Update verfügbar"
  },
  "app-update-modal": {
    "desc": "Um Ihre Anwendung zu aktualisieren, müssen Sie die neue Version generieren und dem Update-Tutorial folgen.",
    "title": "Update Ihrer Anwendung"
  },
  "assets": {
    "app-logo": "App-Logo",
    "app-logo-explained": "Dieses Bild entspricht dem Logo Ihrer App.",
    "app-logo-size": "Empfohlene Größe: 2500px x 2500px",
    "app-name": "Name deiner Radio-App",
    "apple-only": "Nur auf Apple",
    "change-image": "Bild ersetzen",
    "constraints-icon-smartphone": "Empfohlene Größe: 1024 x 1024px",
    "constraints-icon-tv": "Empfohlene Größe: 1280 x 768px",
    "constraints-smartphone": "Empfohlene Größe: 1242 x 2208px",
    "constraints-smartphone-long": "Empfohlene Größe: 1242 x 2688px",
    "constraints-topshelf-tv": "Empfohlene Größe: 4640 x 1440px",
    "constraints-tv": "Empfohlene Größe: 3840 x 2160px",
    "crop-image": "Bild zuschneiden",
    "icon-tv": "Symbol für TV-Apps",
    "icon-tv-description": "Dieses Symbol wird auf der Startseite von TV-Apps angezeigt.",
    "images-title": "Bildschirme und Logos",
    "large-screen": "Großer Bildschirm",
    "logo": "App-Symbol",
    "logo-description": "Dieses Bild stellt das Symbol dar, das der Nutzer anklickt, um die Anwendung zu starten.",
    "next-step": "Nächster Schritt",
    "restrictions": "Technische Einschränkungen",
    "restrictions-icon-tv": "Muss den vollständigen Namen der Anwendung enthalten, ohne abgeschnittenen Text oder die Angabe einer FM-Frequenz, außer wenn im Namen vorhanden",
    "restrictions-splashscreen-tv": "Weder das Bild noch der Text dürfen abgeschnitten werden",
    "smartphone": "Smartphone",
    "smartphone-description": "Dieses Bild wird beim Starten der App angezeigt.",
    "smartphone-long-description": "Dieses Bild wird beim Starten der App auf großen Smartphones angezeigt.",
    "splashscreens": "Startbildschirme",
    "splashscreens-explained": "Dieses Bild wird beim Starten der App auf verschiedenen Geräten (Telefon, TV) angezeigt.",
    "splashscreens-size": "Empfohlene Größe: 2500px x 2500px",
    "topshelf-tv-description": "Bildvorschau der App in der Apple TV-Oberfläche.",
    "topshelf-tv-short": "TV-Banner",
    "tv": "TV-Bildschirm",
    "tv-description": "Dieses Bild wird beim Starten der App auf einem Fernseher angezeigt.",
    "update-image-title": "Bildschirme und Logos"
  },
  "audio-dedications": {
    "choose-radio": "Wählen Sie ein Radio",
    "end": "Ende",
    "end-placeholder": "Vielen Dank für Ihre Widmung!",
    "need-a-rk-radio": "⚠️ Diese Seite benötigt einen RadioKing-Stream, um zu funktionieren.",
    "radio": "Radio",
    "rk-create-radio-cta": "Mein Radio erstellen",
    "rk-radio-create-link": "/ueberblick",
    "text": "Text",
    "welcome": "Willkommen",
    "welcome-placeholder": "Senden Sie Ihre Widmung auf Sendung!"
  },
  "changelog": {
    "fixes": "Fehlerbehebungen",
    "improvement": "Verbesserungen",
    "new": "Neuigkeiten",
    "read-more": "Mehr sehen",
    "title": "Changelog"
  },
  "color-selector": {
    "hex-error": "Der Farbcode ist nicht korrekt.",
    "opacity": "Deckkraft",
    "opacity-error": "Die Deckkraft muss zwischen 0 und 100 liegen."
  },
  "config-submenu": {
    "content": "Inhalt",
    "design": "Design"
  },
  "create-app-form": {
    "change-image": "Bild ändern",
    "choose-name": "Name der App wählen",
    "choose-name-explained": "Wählen Sie einen einzigartigen Namen für Ihre mobile App. Sie können ihn später bei Bedarf ändern.",
    "max-length": "Maximale Länge: 30 Zeichen.",
    "min-length": "Minimale Länge: 2 Zeichen.",
    "missing-name": "Ein Name ist erforderlich.",
    "name-placeholder": "Name Ihrer App",
    "no-emojis": "Emojis sind nicht erlaubt.",
    "no-spaces-only": "Der Name darf nicht nur aus Leerzeichen bestehen.",
    "start": "Starten",
    "unavailable-name": "Dieser App-Name ist bereits vergeben."
  },
  "dashboard": {
    "consumption": "Benachrichtigungsverbrauch",
    "hello": "Hallo",
    "new-subscribers": "Neue Abonnenten in den letzten 7 Tagen",
    "new-subscribers-unit": "{count, plural, =1 {Neuer Abonnent} other {Neue Abonnenten}}",
    "notifications-sent": "Versendete Benachrichtigungen",
    "notifications-sent-unit": "{count, plural, =1 {Benachrichtigung} other {Benachrichtigungen}}",
    "subscriber-detail": "Benutzerverteilung",
    "subscribers-total": "Abonnenten für Benachrichtigungen",
    "title": "Benachrichtigungsstatistiken",
    "welcome": "Willkommen in Ihrem Dashboard."
  },
  "general-configuration": {
    "app-langugage": "App-Sprache",
    "background-color": "Farbe 1",
    "background-color-2": "Farbe 2",
    "background-color-style": "Stil",
    "background-gradient-direction": "Richtung",
    "bicolor-color-tooltip": "Zweifarbig",
    "blur": "Unschärfe",
    "blur-details": "Die Hintergrundunschärfe fügt Ihrem Bild einen visuellen Effekt hinzu, um den Hauptinhalt hervorzuheben.",
    "body-size": "Körpergröße",
    "button-color": "Button-Farbe",
    "button-label": "Button",
    "button-type": "Button-Typ",
    "color": "Farbe",
    "cover": "Cover",
    "cover-background-details": "Das aktuelle Titelcover wird als Hintergrundbild angezeigt.",
    "default-background-image": "Standardbild",
    "font-size": "Textgröße",
    "gradient-color-tooltip": "Verlauf",
    "header": "Kopfzeile",
    "header-text-color": "Textfarbe der Kopfzeile",
    "icons": "Symbole",
    "image": "Bild",
    "invert-colors": "Farben umkehren",
    "long-background-image": "Langformatiges Bild",
    "rounded-borders": "Abgerundete Ecken",
    "shodow-box": "Schatten",
    "show-logo": "Logo anzeigen",
    "solid-color-tooltip": "Einfarbig",
    "styles": "Stile",
    "styles-background": "Hintergrund",
    "text-align": "Textausrichtung",
    "typography": "Typografie"
  },
  "global": {
    "cancel": "Abbrechen",
    "share": "Teilen",
    "url-copied": "Die URL wurde erfolgreich in die Zwischenablage kopiert.",
    "url-copy-failed": "Die URL konnte nicht in die Zwischenablage kopiert werden. Bitte versuchen Sie es erneut.",
    "url-invalid": "Die URL ist nicht korrekt",
    "validate": "Bestätigen"
  },
  "header": {
    "help-link": "https://help.radioking.com/hc/de/categories/4408651163665-Mobile-application"
  },
  "html-config": {
    "background": "Hintergrund des HTML-Blocks",
    "code-placeholder": "Geben Sie Ihren HTML-Code ein",
    "content": "Seiteninhalt"
  },
  "icon-search": {
    "icon-name": "Name des Symbols"
  },
  "icon-type-selector": {
    "regular": "Umriss",
    "solid": "Gefüllt"
  },
  "image-cropper": {
    "cancel": "Abbrechen",
    "iconTv": "TV-App-Symbol ändern",
    "logo": "App-Symbolbild ändern",
    "recommended": "Empfohlene Größe",
    "replace": "Bild ändern",
    "restrictions": "Technische Einschränkungen",
    "rotation": "Rotation",
    "save": "Speichern",
    "splashscreen": "Startbildschirmbild ändern",
    "splashscreenLarge": "Großen Startbildschirm ändern",
    "splashscreenTv": "TV-Startbildschirm ändern",
    "topShelfTv": "TV-Bannerbild ändern",
    "zoom": "Zoom"
  },
  "image-input": {
    "cancel": "Abbrechen",
    "dragging-over-text": "Lassen Sie Ihr Bild los, um es hochzuladen",
    "load": "Laden",
    "main-text": "Drag & Drop \noder"
  },
  "image-size-guide": {
    "size": "Empfohlene Größe: \n{width} x {height}px\nMaximales Gewicht: 10 MB"
  },
  "image-upload": {
    "alt": "Hochgeladenes Bild",
    "change-image": "Bild ändern",
    "constraints-title": "Technische Einschränkungen",
    "delete": "Löschen",
    "file-size-error": "Die Datei darf maximal 10 MB groß sein",
    "file-type-error": "Akzeptierte Formate: .jpg, .jpeg, .png"
  },
  "ios-publishing-empty-state": {
    "cta": "Auf Premium upgraden",
    "desc": "Ihre Hörer sind auch auf dem iPhone. Fügen Sie die iOS-Option hinzu und bieten Sie ihnen eine vollständige Erfahrung direkt aus dem App Store.",
    "title": "Ihre Anwendung auf iOS"
  },
  "ios-screenshot": {
    "desc": "<p class='mb-[10px]'>Das angezeigte Bild entspricht der bei der Veröffentlichung generierten Vorschau. Dieser Status zeigt an, dass Ihre App zum ersten Mal online gestellt wurde.</p><p>Es wird nicht automatisch aktualisiert: Updates, Überprüfungen oder Warnungen müssen über Ihr Apple-Entwicklerkonto verfolgt werden.</p>",
    "title": "Ihre Anwendung ist jetzt im Apple Store verfügbar."
  },
  "login": {
    "login-button": "Anmelden"
  },
  "margin-settings": {
    "no-margin": "Ohne Ränder",
    "with-margin": "Mit Rändern"
  },
  "menu-content": {
    "title-error": "Der Seitenname muss mindestens zwei Zeichen lang sein"
  },
  "menu-design": {
    "background": "Hintergrund",
    "show-logo": "Logo anzeigen",
    "styles": "Stile",
    "text-color": "Textfarbe"
  },
  "menu": {
    "configuration": "Konfiguration",
    "content": "Design und Inhalt",
    "dashboard": "Dashboard",
    "notifications": "Benachrichtigungen",
    "pages": "Seiten",
    "publication": "Veröffentlichung",
    "publishing": "Veröffentlichung",
    "settings": "Einstellungen"
  },
  "mobile-access-warning": {
    "cta": "Zur Desktop-Version wechseln",
    "description": "Der Simulator ist auf Mobilgeräten nicht verfügbar, aber Sie können über die Desktop-Version darauf zugreifen.",
    "description-app-manager": "Der App-Manager ist auf Mobilgeräten nicht verfügbar, aber Sie können über die Desktop-Version darauf zugreifen.",
    "title": "Zur Desktop-Version wechseln"
  },
  "mock-tabs": {
    "alarm": "Alarm",
    "dedications": "Widmungen",
    "podcast": "Podcast",
    "podcast-link": "https://feed.ausha.co/o9W6DIj52NE0",
    "rss": "RSS-Feed",
    "rss-link": "https://de.radioking.com/blog/feed",
    "rss-news": "Nachrichten",
    "rss-podcasts": "Podcast",
    "rss-video": "Video",
    "shout-outs": "Audio-Shoutouts",
    "song-history": "Song-Verlauf",
    "video-link": "https://www.youtube.com/feeds/videos.xml?channel_id=UCuA6ECflXH9hpx5iDBa79uw",
    "website": "Website"
  },
  "monetization": {
    "ad-unit-id": "Anzeigenblock-ID",
    "admob-configuration-tutorial": "Wie konfiguriere ich AdMob?",
    "admob-configuration-tutorial-url": "https://help.radioking.com/hc/de/articles/4410223563025",
    "admob-get-id-tutorial": "Wie Sie Ihre AdMob-IDs erhalten?",
    "admob-get-id-tutorial-url": "https://help.radioking.com/hc/de/articles/4410238783377",
    "and": "und",
    "android-app-id": "Android-App-ID",
    "banner": "Banner",
    "banner-description": "Werbung, die auf der Player-Seite der App angezeigt wird.",
    "change-offer-text": "Wechseln Sie zum höheren Angebot, um die Monetarisierung zu aktivieren. Eine einfache Lösung, um mit Ihrer App Einnahmen zu generieren.",
    "configure-later": "Sie können die Monetarisierung jetzt einrichten oder später aktivieren.",
    "description-1": "Google AdMob ermöglicht es Ihnen, Ihre App durch das Anzeigen von Werbung zu monetarisieren.",
    "description-2": "Um Admob einzurichten, gehen Sie auf die AdMob-Website",
    "interstitial": "Interstitial",
    "interstitial-description": "Werbung, die beim Öffnen der App angezeigt wird.",
    "ios-app-id": "iOS-App-ID",
    "next-step": "Nächster Schritt",
    "option-toggle": "Werbung aktivieren",
    "our-tutorials": "zu unseren Tutorials",
    "title": "Monetarisierung"
  },
  "new-stream": {
    "name": "Mein Radio"
  },
  "notification-congrats-dialog": {
    "button": "Starten",
    "desc": "Übernehmen Sie mühelos die volle Kontrolle über Ihre mobile App! Passen Sie sie an, senden Sie Benachrichtigungen, und verfolgen Sie Ihre Leistung direkt von Ihrem Dashboard aus.",
    "title": "Herzlichen Glückwunsch zur Einrichtung Ihrer Anwendung!"
  },
  "notification-dashboard": {
    "empty-state": {
      "desc": "Ihre Anwendung wurde soeben veröffentlicht. Ihre ersten Ergebnisse erscheinen bald auf diesem Dashboard.",
      "title": "Sie haben noch keine Statistiken",
      "tutorial": {
        "card1": {
          "desc": "Lernen Sie, wie Sie Ihre Push-Benachrichtigungen versenden, gezielt einsetzen und analysieren, um Ihre Zuhörer effektiv zu binden.",
          "title": "Alles über Push-Benachrichtigungen",
          "url": "https://help.radioking.com/hc/de/articles/4410238827409"
        },
        "card2": {
          "desc": "Entdecken Sie, wie Sie Ihre mobile Anwendung einfach konfigurieren, aktualisieren und veröffentlichen können.",
          "title": "Alles über die Mobile App",
          "url": "https://help.radioking.com/hc/de/categories/4408651163665"
        },
        "learn-more": "Erfahren Sie mehr",
        "title": "Lassen Sie sich von uns führen"
      }
    },
    "send": "Benachrichtigung gesenden",
    "title": "Benachrichtigungen",
    "total": "{count, plural, =0 {Senden Sie Ihre erste Benachrichtigung} =1 {Sie haben eine Benachrichtigung gesendet} other {Sie haben # Benachrichtigungen gesendet}}"
  },
  "notification-form": {
    "cancel": "Abbrechen",
    "close-confirmation-button": "Ja, beenden",
    "close-confirmation-message": "Sind Sie sicher, dass Sie das Erstellen Ihrer Benachrichtigung verlassen möchten?",
    "close-confirmation-message-details": "Das Schließen des aktuellen Fensters führt zum Verlust der Änderungen. Sind Sie sicher, dass Sie ohne Speichern verlassen möchten?",
    "close-confirmation-tooltip": "Ein Fehler ist in Ihrer Benachrichtigung aufgetreten. Überprüfen Sie das Formular, bevor Sie es speichern.",
    "date-placeholder": "Wählen Sie ein Datum",
    "deeplink": "Tiefverlinkung",
    "deeplink-desc": "Beim Klicken auf die Benachrichtigung wird der Hörer zur ausgewählten Seite weitergeleitet.",
    "deeplink-placeholder": "Seite auswählen",
    "draft": "Entwurf speichern",
    "episode-placeholder": "Episode auswählen",
    "episode-selection": "Episode (optional)",
    "language": "Sprache",
    "language-placeholder": "Wählen Sie Ihre Sprache(n)",
    "location": "Standort",
    "location-placeholder": "Land, Stadt, Region, ...",
    "location-search": "Standortbasierte Benachrichtigung senden",
    "message": "Nachricht",
    "message-error": "Die Nachricht muss zwischen 3 und 140 Zeichen enthalten.",
    "message-placeholder": "Schreiben Sie Ihre Nachricht",
    "new": "Neue Benachrichtigung",
    "os": "Betriebssystem",
    "platform-error": "Wählen Sie mindestens ein Betriebssystem",
    "podcast-placeholder": "Podcast auswählen",
    "podcast-selection": "Podcast-Titel (optional)",
    "radio-placeholder": "Radio auswählen",
    "radio-selection": "Radio",
    "schedule": "Planen",
    "send": "Senden",
    "time-placeholder": "Uhrzeit",
    "title": "Titel",
    "title-error": "Der Titel (optional) muss zwischen 3 und 50 Zeichen enthalten.",
    "title-placeholder": "Titel Ihrer Benachrichtigung",
    "tooltip-support-ios": "Wechseln Sie zum höheren Abo, um Benachrichtigungen auf iOS zu senden.",
    "tooltip-unavailable-android": "Benachrichtigungen sind für Ihre Android-App noch nicht verfügbar.",
    "tooltip-unavailable-ios": "Benachrichtigungen sind für Ihre iOS-App noch nicht verfügbar."
  },
  "notification-sidebar": {
    "empty-state": {
      "desc": "Nach dem ersten Senden ist Ihr Benachrichtigungsverlauf verfügbar",
      "title": "Senden Sie Ihre erste Benachrichtigung"
    },
    "scheduled": "Geplant"
  },
  "notification-table": {
    "android": "Senden auf Android",
    "date": "Sendedatum",
    "draft": "Entwurf",
    "empty-state-desc": "Lassen Sie Ihre Hörer wissen, was es Neues in Ihrem Radio gibt, welche Veranstaltungen stattfinden und vieles mehr.",
    "ios": "Senden auf iOS",
    "message": "Nachricht",
    "not-sent-android": "Diese Benachrichtigung wurde nicht auf Android gesendet",
    "not-sent-ios": "Diese Benachrichtigung wurde nicht auf iOS gesendet",
    "reach": "Gesamtsendungen"
  },
  "notification-targeted-subscribers": {
    "android": "auf Android",
    "ios": "auf iOS",
    "total": "Geschätzte Sendungen"
  },
  "onboarding-modal": {
    "content-design": {
      "button": "Ausgabe fortsetzen",
      "desc": "Verwenden Sie die Registerkarten, um zwischen der Bearbeitung des Inhalts und der Anpassung des Designs der ausgewählten Seite umzuschalten.",
      "title": "Inhalt und Design"
    },
    "general-configuration": {
      "desc": "Passen Sie die Design-Konfiguration Ihrer mobilen Anwendung an Ihre spezifischen Bedürfnisse an.",
      "title": "Design-Konfiguration"
    },
    "interface": {
      "button": "Beenden",
      "desc": "Passen Sie die visuellen Elemente Ihrer Anwendung an. Passen Sie Sprache, Farben, Typografie und Symbole an, um eine einzigartige Nutzererfahrung zu schaffen.",
      "title": "Anpassen der Schnittstelle"
    },
    "menu": {
      "desc": "Organisieren und passen Sie das Menü Ihrer mobilen Anwendung an, damit Ihre Hörer optimal navigieren können.",
      "title": "Verwaltung des Menüs"
    },
    "next": "Weiter zu",
    "pages": {
      "desc": "Erstellen, bearbeiten und organisieren Sie die Seiten Ihrer mobilen Anwendung.",
      "title": "Seiten verwalten"
    },
    "previous": "Vorherige",
    "stepper": {
      "button": "Zum nächsten Schritt übergehen",
      "desc": "Hier sehen Sie, wie weit Sie bei jedem Schritt Ihres Projekts gekommen sind. Klicken Sie auf „Nächster Schritt“, um fortzufahren.",
      "title": "Verfolgen Sie Ihren Fortschritt"
    }
  },
  "other-config": {
    "need-a-rk-website": "Diese Seite benötigt eine RadioKing-Website, um zu funktionieren.",
    "rk-website-create-link": "/website",
    "rk-website-cta": "Meine Radio-Website erstellen",
    "rk-website-link": "Link zu Ihrer Radio-Website",
    "rss-link": "RSS-Feed-Link",
    "website-link": "Website-Link",
    "what-is-rss": "Ein <strong>RSS-Feed</strong> ist ein Weblink, der automatisch mit Ihrem neuesten Inhalt aktualisiert wird.<br/>Wenn Sie Ihren RSS-Feed nicht finden können, überprüfen Sie Ihre Content-Plattform oder Ihren Hosting-Service; er ist normalerweise als 'RSS-Feed' oder 'Feed-URL' gekennzeichnet."
  },
  "page-config": {
    "background-color": "Hintergrundfarbe",
    "header-text-color": "Textfarbe der Kopfzeile der Kopfzeile",
    "icon-and-name": "Symbol und Seitenname"
  },
  "paid-publication-modal": {
    "buy": "In den Warenkorb legen",
    "buy-android": "Auf Android veröffentlichen",
    "buy-ios": "Auf iOS veröffentlichen",
    "cancel": "Abbrechen",
    "message": "Für {price} pro Plattform übernimmt RadioKing die Veröffentlichung Ihrer Anwendung in Ihren Apple- oder Google-Entwicklerkonten unter Einhaltung der Store-Anforderungen. <a target='_blank' href='https://de.radioking.com/app-veroffentlichung' class='underline text-brand'>Entdecken Sie die Schritte, die im Detail durchgeführt werden.</a>",
    "title": "Veröffentlichung durch RadioKing"
  },
  "plan": {
    "all-basic": "Alle Basic-Angebot-Funktionen",
    "all-smart": "Alle Smart-Angebot-Funktionen",
    "android": "Native <b>Android</b>-App",
    "android-and-ios": "Native <b>Android & iPhone</b>-App",
    "android-tablet": "Kompatibel mit <b>Android-Tablet</b>",
    "annual": "Jährlich",
    "apple-watch": "<b>Apple Watch</b>",
    "auto": "<b>Android Auto & Apple CarPlay</b>",
    "carplay-tooltip": "Vorbehaltlich der Genehmigung durch Apple (1-3 Wochen) für CarPlay",
    "choose": "Dieses Angebot wählen",
    "customizable": "100% anpassbares Design",
    "monetization": "Monetarisierung",
    "monetization-tooltip": "Werbeverwaltung: AdMob",
    "monthly": "Monatlich",
    "multi-language": "Mehrsprachig",
    "multi-language-tooltip": "Wählen Sie zwischen 6 verschiedenen Sprachen bei der App-Erstellung: FR, EN, ES, DE, IT, PT",
    "multi-stream": "Multi-Stream-Radio",
    "multi-stream-tooltip": "Kompatibel mit Shoutcast, Icecast & anderen Anbietern",
    "per-month": "/Monat",
    "per-year": "/Jahr",
    "pick-title": "Mein Angebot wählen",
    "plus": "plus",
    "publication-tooltip": "Gültig für 1 Veröffentlichung",
    "push": "<b>{number}</b> Push-Benachrichtigungen",
    "push-tooltip": "<b>Zusätzliche Benachrichtigungen:</b></br>100.000: +5{currency}/Monat</br>300.000: +15{currency}/Monat</br>500.000: +25{currency}/Monat</br>750.000: +35{currency}/Monat",
    "recommended": "Empfohlenes Angebot",
    "rk-published": "App-Veröffentlichung durch RadioKing <b>INKLUSIVE</b>",
    "subtitle": "Wählen Sie das Angebot, das Sie und Ihr Team benötigen.",
    "tablet": "Kompatibel mit <b>iPad & Android-Tablet</b>",
    "tv": "<b>Android TV & Apple TV</b>",
    "two-months-free": "2 Monate kostenlos",
    "unlimited-downloads": "Unbegrenzter <b>App-Download</b>",
    "unlimited-tabs": "Unbegrenzte <b>Tabs</b>",
    "user-published": "App-Veröffentlichung durch den Benutzer (Option)",
    "user-published-tooltip": "50{currency} pro App-Veröffentlichung",
    "white-label": "White-Label",
    "white-label-tooltip": "White Label ermöglicht es Ihnen, jegliches 'RadioKing'-Branding aus Ihrer Anwendung zu entfernen."
  },
  "player-buttons": {
    "apple": "Über Apple Music kaufen",
    "apple-afiliate-help-link": "https://help.radioking.com/hc/de/articles/4409541483665",
    "apple-music-placeholder": "Ihre Apple Music Affiliate-ID",
    "auto-play": "Auto-Play",
    "email": "E-Mail",
    "email-error": "Die E-Mail ist nicht korrekt",
    "infobox-itunes": "💡 Der Button 'Über Apple Music kaufen' ermöglicht es Ihren Hörern, den aktuellen Titel zu kaufen. Dies ist eine großartige Möglichkeit, Ihre App zu monetarisieren.<br/><br/>Um davon zu profitieren, müssen Sie sich beim Apple-Affiliate-Programm anmelden.",
    "infobox-itunes-cta": "Erfahren Sie mehr",
    "mail-placeholder": "contact@mein-radio.com",
    "other-actions": "Weitere Aktionen",
    "phone": "Anruf",
    "phone-error": "Die Telefonnummer ist nicht korrekt",
    "phone-placeholder": "+49 1 23 45 67 89",
    "share": "Teilen",
    "sleep-timer": "Schlaftimer",
    "sms": "SMS",
    "sms-placeholder": "+49 1 23 45 67 89",
    "title": "Buttons",
    "vote": "Abstimmen",
    "vote-explained": "Die Abstimmungsfunktion ermöglicht es Ihren Hörern, Ihnen mitzuteilen, wenn sie Ihre Musik mögen. Diese Funktion ist nur für Radios verfügbar, die von RadioKing gehostet werden."
  },
  "player-content": {
    "icon-and-name": "Symbol und Seitenname",
    "stream": "Radio-Stream"
  },
  "player-design": {
    "always-show-default-cover": "Standard-Cover immer anzeigen",
    "artist-color": "Farbe des Künstlers",
    "constraints-body": "Empfohlene Größe: 440 x 440px\nMaximales Gewicht: 10 MB\nAkzeptierte Formate: .jpg, .jpeg, .png",
    "cover": "Standard-Cover",
    "cover-border-color": "Randfarbe des Covers",
    "cover-explained": "Das Standard-Cover ist das Bild, das das Titelbild ersetzt, wenn kein solches vorhanden ist.",
    "cover-shape": "Form des Covers",
    "cover-type": "Cover-Stil",
    "show-cover-border": "Cover-Rand anzeigen",
    "title-and-artist": "Titel und Künstler",
    "title-color": "Farbe des Titels",
    "titling-background": "Hintergrund"
  },
  "privacy": {
    "description": "Konfigurieren Sie die Einstellungen Ihrer Consent Management Platform (CMP) für die DSGVO-Konformität.",
    "didomi-api-key": "Didomi API-Schlüssel",
    "didomi-api-key-placeholder": "Geben Sie Ihren Didomi API-Schlüssel ein",
    "didomi-notice-id": "Didomi Notice ID",
    "didomi-notice-id-placeholder": "Geben Sie Ihre Didomi Notice ID ein",
    "option-toggle": "Didomi CMP aktivieren",
    "privacy-policy-url": "URL der Datenschutzerklärung",
    "privacy-policy-url-placeholder": "https://beispiel.de/datenschutz",
    "terms-of-service-url": "URL der Nutzungsbedingungen",
    "terms-of-service-url-placeholder": "https://beispiel.de/agb",
    "title": "Datenschutz"
  },
  "podcast-config": {
    "add": "Podcast hinzufügen",
    "duplicate": "Diese Podcast-URL wurde bereits hinzugefügt",
    "episodes": "Episoden",
    "feed-link": "Podcast-Feed-Link",
    "invalid": "Die eingegebene URL ist kein Podcast-RSS-Feed"
  },
  "publication-addon-dialog": {
    "accept": "RadioKing veröffentlicht für mich",
    "message": "Wir übernehmen die vollständige Veröffentlichung Ihrer App in Ihren Apple- und Google-Entwicklerkonten. Überlassen Sie uns diese Aufgabe, damit Ihre App schnell online ist und den Plattformanforderungen entspricht.<br/><br/>Diese Option kostet nur {price} einmalig.<br/><br/>Wenn Sie selbst veröffentlichen möchten, helfen Ihnen unsere Tutorials Schritt für Schritt.",
    "refuse": "Ich veröffentliche selbst",
    "title": "Möchten Sie, dass RadioKing die App für Sie veröffentlicht?"
  },
  "publishing-banner": {
    "cta": "Veröffentlichen",
    "description": "Für 50€ pro Plattform kümmert sich RadioKing um die Veröffentlichung Ihrer Anwendung auf Ihren Apple- oder Google-Entwicklerkonten, gemäß den Anforderungen der Stores. ",
    "link": "https://de.radioking.com/app-veroffentlichung",
    "link-description": "Erfahren Sie mehr über die Veröffentlichung durch RadioKing.",
    "title": "RadioKing veröffentlicht für mich"
  },
  "publishing-step": {
    "android-dev-account-cta": "Mein Konto erstellen",
    "android-dev-account-description": "Die Erstellung und Validierung Ihres Google-Entwicklerkontos ist erforderlich, um Ihre Anwendung zu veröffentlichen. Weitere Informationen finden Sie in unserem Tutorial.",
    "android-dev-account-label": "Mein Play Store-Konto erstellen",
    "android-tutorial-description": "Folgen Sie der Anleitung, um Ihre Anwendung bei Google einzureichen und sie im Play Store zu veröffentlichen.",
    "android-tutorial-label": "Die Anwendung in den Play Store hochladen",
    "download-cta": "Meine Anwendung herunterladen",
    "download-description": "Laden Sie Ihr Bewerbungsarchiv herunter. Dieses Archiv ist für die Veröffentlichung in den Geschäften erforderlich.",
    "download-label": "Die Anwendung herunterladen",
    "existing-dev-account": "Ich habe bereits ein Konto",
    "generation-cta": "Generierung starten",
    "generation-description": "Dieser Schritt startet den automatischen Prozess der Erstellung Ihrer Anwendung aus den von Ihnen bereitgestellten Elementen (Name, Symbol, Inhalt usw.). Sobald die Generierung abgeschlossen ist, können Sie die für die Veröffentlichung erforderlichen Dateien herunterladen.",
    "generation-label": "Die Anwendung generieren",
    "in-progress": "Wird bearbeitet",
    "ios-carplay-cta": "CarPlay-Autorisierung anfordern",
    "ios-carplay-description": "Fordern Sie bei Apple die Autorisierung an, um Ihre Anwendung mit CarPlay kompatibel zu machen. Dies kann mehrere Wochen dauern.",
    "ios-carplay-label": "CarPlay-Autorisierung anfordern",
    "ios-dev-account-cta": "Mein Konto erstellen",
    "ios-dev-account-description": "Die Erstellung und Validierung Ihres Apple-Entwicklerkontos ist erforderlich, um Ihre Anwendung zu veröffentlichen. Weitere Informationen finden Sie in unserem Tutorial.",
    "ios-dev-account-label": "Mein App Store-Konto erstellen",
    "ios-tutorial-description": "Folgen Sie der Anleitung, um Ihre Anwendung bei Apple einzureichen und sie im App Store zu veröffentlichen.",
    "ios-tutorial-label": "Ihre Anwendung in den App Store hochladen",
    "published-label": "Herzlichen Glückwunsch, Ihre Anwendung ist online!",
    "tutorial-cta": "Veröffentlichung starten"
  },
  "publishing": {
    "app-swap": "Anwendung wechseln",
    "subtitle": "Veröffentlichen Sie Ihre Anwendung Schritt für Schritt und überwachen Sie ihren Veröffentlichungsstatus",
    "title": "Veröffentlichungsstatus"
  },
  "setting-confirmation-modal": {
    "cancel": "Abbrechen",
    "description": "Damit Ihre Einstellungsänderungen für Benutzer sichtbar werden, muss Ihre Anwendung neu veröffentlicht werden.",
    "documentation": "dokumentation",
    "link": "https://help.radioking.com/hc/de/articles/26106170721041",
    "link-description": "Weitere Informationen finden Sie in unserer ",
    "save": "Nur speichern",
    "save-redirect": "Speichern und veröffentlichen",
    "title": "Änderungen veröffentlichen"
  },
  "settings-list": {
    "general-configuration": "Thema-Einstellungen",
    "menu": "Menü",
    "pages": "Seiten"
  },
  "simulator-preview": {
    "add-image-text": "Laden Sie ein Bild hoch, um eine Vorschau zu sehen",
    "add-image-title": "Fügen Sie Ihr Bild hinzu"
  },
  "song-history-config": {
    "api-url": "API-URL",
    "api-url-description": "API, die den Verlauf der zuletzt gespielten Titel bereitstellt.",
    "search-api-url": "Such-API-URL",
    "search-api-url-description": "API, die die Suche nach Titeln im Verlauf ermöglicht."
  },
  "stepper": {
    "design": "Design und Inhalt",
    "images": "Erstellung",
    "last": "Jetzt sind Sie dran",
    "monetization": "Monetarisierung",
    "name": "Name",
    "next": "Nächster Schritt",
    "plan": "Angebot",
    "previous": "Vorheriger Schritt",
    "save": "Speichern"
  },
  "stream-list": {
    "search-placeholder": "Stream suchen",
    "empty-search-title": "Kein Stream gefunden",
    "empty-search-description": "Versuchen Sie ein anderes Stichwort.",
    "sort-confirm-title": "Alphabetisch sortieren?",
    "sort-confirm-message": "Die aktuelle Reihenfolge Ihrer Streams wird durch eine alphabetische Sortierung ersetzt.",
    "sort-confirm-button": "Sortieren",
    "cancel": "Abbrechen"
  },
  "stream-list-item": {
    "edit": "Bearbeiten",
    "move-to-top": "Ganz nach oben",
    "move-to-bottom": "Ganz nach unten",
    "delete": "Löschen",
    "delete-confirm-title": "Diesen Stream löschen?",
    "delete-confirm-message": "Sind Sie sicher, dass Sie diesen Stream löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    "delete-confirm-button": "Löschen",
    "cancel": "Abbrechen"
  },
  "stream-edit": {
    "choose-mountpoint": "Wählen Sie Ihren Mountpoint",
    "choose-radio": "Wählen Sie Ihr Radio",
    "logo": "Stream-Logo",
    "mount-point": "Mountpoint",
    "name": "Name des Streams",
    "other": "MP3 / AAC",
    "radio": "Radio",
    "radioking-no-radios-error": "Sie müssen einen RadioKing-Stream besitzen, um diese Option auszuwählen.",
    "stream-type": "Stream-Typ",
    "stream-url": "Stream-URL",
    "title-url": "Titel-URL",
    "title-url-infobox": "💡 Bitte geben Sie eine URL einer Webseite ein, die ausschließlich 'Künstler - Titel des Liedes' anzeigt.",
    "url-hls-not-allowed": "Nur HLS-Streams dürfen eine .m3u8-URL verwenden",
    "url-required": "Eine URL ist erforderlich"
  },
  "stream-modal": {
    "title-add": "Stream hinzufügen",
    "title-edit": "Stream bearbeiten",
    "name-placeholder": "Name des Streams",
    "type-placeholder": "Typ auswählen",
    "title-url-description": "Teilen Sie die URL einer Seite, die nur Folgendes enthält: 'Künstler - Titel des Liedes'",
    "cancel": "Abbrechen",
    "confirm-close": "Das Schließen dieses Fensters führt zum Verlust der aktuellen Änderungen. Möchten Sie wirklich ohne Speichern beenden?",
    "add": "Hinzufügen",
    "save": "Speichern",
    "duplicate-url": "Dieser Stream wird bereits von {name} verwendet"
  },
  "toast": {
    "generic-error": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
    "generic-fetch-error": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
    "login_error": "Das Passwort und/oder der Benutzername ist falsch.",
    "notification-deleted": "Ihre Benachrichtigung wurde gelöscht.",
    "notification-draft": "Ihr Entwurf wurde gespeichert.",
    "notification-frequency-error": "Sie müssen mindestens 5 Minuten Abstand zwischen den Benachrichtigungen einhalten.",
    "notification-quota-error": "Ihr Limit wurde überschritten. Sie haben zu viele Push-Benachrichtigungen gesendet.",
    "notification-scheduled": "Benachrichtigung geplant.",
    "notification-sent": "Benachrichtigung gesendet.",
    "notification-updated": "Benachrichtigung aktualisiert.",
    "post-config-success": "Ihre Änderungen wurden erfolgreich gespeichert."
  },
  "tutorial-modal": {
    "close": "Später anzeigen",
    "validate": "Ich bin fertig"
  },
  "unsaved-changes-dialog": {
    "cancel": "Abbrechen",
    "close-confirmation-button": "Schließen ohne zu speichern",
    "close-confirmation-message": "Schließen ohne zu speichern",
    "close-confirmation-message-details": "Möchten Sie wirklich schließen, ohne die Änderungen zu speichern?"
  },
  "update-content": {
    "save": "Speichern",
    "subtitle": "Ändern Sie das Design und den Inhalt Ihrer Anwendung.",
    "title": "Design und Inhalt"
  },
  "update-settings": {
    "nav": {
      "logos": "Bildschirme und Logos",
      "monetization": "Monetarisierung",
      "name": "Name",
      "privacy": "Datenschutz"
    },
    "save": "Speichern und veröffentlichen",
    "subtitle": "Ändern Sie die Einstellungen Ihrer Anwendung.",
    "title": "Einstellungen"
  },
  "update_toast": {
    "update-available": "Ein Update ist verfügbar.",
    "update-now": "Jetzt aktualisieren"
  },
  "upgrade-offer": {
    "button": "Zum höheren Angebot wechseln",
    "description": "Informieren Sie Ihre Zuhörer in Echtzeit mit personalisierten und präzisen Benachrichtigungen (gefiltert nach Land, Sprache, Plattform und mehr). Nutzen Sie diese Möglichkeit, um Ihre Sichtbarkeit zu steigern!",
    "image": "/assets/smartphone-notif-example-en.png",
    "title": "Maximieren Sie das Engagement Ihrer Zuhörer mit gezielten Benachrichtigungen"
  },
  "user-menu": {
    "customer": "Kundenbereich",
    "help": "Hilfezentrum",
    "logout": "Abmelden",
    "news": "Neuigkeiten",
    "news-link": "https://headwayapp.co/radioking-en-changelog"
  },
  "welcome-animation": {
    "message": "Vielen Dank, dass Sie sich für RadioKing entschieden haben, um Ihre mobile App zu erstellen! Wir begleiten Sie von der Bearbeitung bis zur Veröffentlichung in den Stores.",
    "welcome": "Willkommen"
  }
}
